import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { getAssignedSubmissions } from 'app/queue/domains/submissions/submissions-selectors';
import { fetchAllAssigned } from 'app/queue/domains/submissions/submissions-actions';
import { selectQuestionQueueAssignments } from 'app/queue/domains/question-queue/question-queue-selectors';
import { selectAssignedPlagiarismCases } from 'app/queue/domains/plagiarism-case-queue/plagiarism-case-queue-selectors';
import List from 'app/queue/components/list';
import { AssignedPlagiarismCaseListItem } from 'app/queue/components/assigned-plagiarism-case-list-item';
import { AssignedSubmissionListItem } from 'app/queue/components/assigned-submission-list-item';
import { AssignedQuestionListItem } from 'app/queue/components/assigned-question-list-item';
import { RootState, useAppDispatch } from 'app/store';

import styles from './active-tasks.module.scss';

export const ActiveTasks: React.FC = () => {
  const assignedSubmissions = useSelector((state: RootState) => getAssignedSubmissions(state));
  const assignedQuestions = useSelector((state: RootState) => selectQuestionQueueAssignments(state));
  const assignedPlagiarismCases = useSelector((state) => selectAssignedPlagiarismCases(state));

  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchAllAssigned());
  }, []);

  const hasItems = assignedSubmissions.length || assignedQuestions.length || assignedPlagiarismCases.length;

  if (!hasItems) {
    return null;
  }

  return (
    <div className={styles['active-tasks']}>
      <h2>{t('queue.overview.toDo')}</h2>
      <List>
        {assignedSubmissions.map((sub) => {
          return <AssignedSubmissionListItem key={sub.id} submission={sub} />;
        })}
        {assignedPlagiarismCases.map((plagiarismCase) => {
          return <AssignedPlagiarismCaseListItem key={plagiarismCase.id} plagiarismCase={plagiarismCase} />;
        })}
        {assignedQuestions.map((assignment) => {
          return <AssignedQuestionListItem key={`question-${assignment.questionID}`} assignment={assignment} />;
        })}
      </List>
    </div>
  );
};
